import React from 'react';
import { BookOpenIcon, CheckIcon, GiftIcon, GlobeIcon } from 'lucide-react';
import { images, offerIncludes } from '../../data/landing';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function Offer() {
  return <section id="offer" className="w-full bg-navy px-5 py-16 md:py-24" data-id="element-216" data-mp="356m3tb2veo08">
      <div className="mx-auto max-w-2xl" data-id="element-217" data-mp="3a5p0a74sblwl">
        <p className="text-center text-sm font-extrabold uppercase tracking-wider text-sky-light" data-id="element-218" data-mp="3a4nq04vlf3fx">Special launch offer</p>
        <h2 className="mt-3 text-center font-serif text-[32px] font-black leading-tight text-white md:text-5xl" data-id="element-219" data-mp="3f2p9gqwxl4rx">
          Here’s everything you’ll receive today
        </h2>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white" data-id="element-220" data-mp="3nvk46qorvi3g">
          <img src={images.product} alt="Everything included in Ortho Treatment Map" className="w-full bg-sky-pale" loading="lazy" data-id="element-221" data-mp="3swggnsn6wckh" />

          <div className="p-6 md:p-8" data-id="element-222" data-mp="1q5axj78inmt">
            <ul className="divide-y divide-navy/10" data-id="element-223" data-mp="1klglokytmeke">
              <li className="flex items-center justify-between gap-4 py-4" data-id="element-224" data-mp="1km9jgwfsxtqe">
                <span className="flex items-center gap-3" data-id="element-225" data-mp="1fm3yu07y97ht">
                  <BookOpenIcon className="h-6 w-6 shrink-0 text-sky" aria-hidden="true" data-id="element-226" data-mp="1foq57wj3tgyg" />
                  <span data-id="element-227" data-mp="1bmwas5zi596q">
                    <span className="block font-extrabold text-navy" data-id="element-228" data-mp="16lytrwq8al6t">Ortho Treatment Map™</span>
                    <span className="text-sm text-muted" data-id="element-229" data-mp="23bpyspw5bqqv">6 Premium Volumes</span>
                  </span>
                </span>
                <span className="font-bold text-muted line-through decoration-alert decoration-2" data-id="element-230" data-mp="1za4ggp0uek9a">$97</span>
              </li>
              <li className="flex items-center justify-between gap-4 py-4" data-id="element-231" data-mp="1ui36j9r5d5mf">
                <span className="flex items-center gap-3" data-id="element-232" data-mp="1pji5x97zgjxg">
                  <GiftIcon className="h-6 w-6 shrink-0 text-sky" aria-hidden="true" data-id="element-233" data-mp="2mzyqkyts1upu" />
                  <span data-id="element-234" data-mp="2n1rz6jnyap0h">
                    <span className="block font-extrabold text-navy" data-id="element-235" data-mp="2i8p1q0g1yvf0">5 Exclusive Bonuses</span>
                    <span className="text-sm text-muted" data-id="element-236" data-mp="315qzk7pcaf6l">Decision cards, protocols, audits & templates</span>
                  </span>
                </span>
                <span className="font-bold text-muted line-through decoration-alert decoration-2" data-id="element-237" data-mp="363seqhjn9ucs">$147</span>
              </li>
              <li className="flex items-center justify-between gap-4 py-4" data-id="element-238" data-mp="2wer12y0knp1z">
                <span className="font-extrabold uppercase tracking-wide text-navy" data-id="element-239" data-mp="2wcxpd4b3qen4">Total value</span>
                <span className="text-xl font-black text-alert line-through decoration-2" data-id="element-240" data-mp="2ih2ftp2lefwe">$244 USD</span>
              </li>
            </ul>

            <div className="mt-6 rounded-2xl bg-sky-pale p-6 text-center" data-id="element-241" data-mp="29et6h2j28skl">
              <p className="text-[17px] font-semibold text-navy" data-id="element-242" data-mp="29gnpgbaruam1">
                But you don’t have to pay $244. You don’t even have to pay $97.
              </p>
              <p className="mt-4 text-sm font-extrabold uppercase tracking-wider text-navy-700" data-id="element-243" data-mp="7ng3wk4kewrp">Today you can get everything for:</p>
              <p className="mt-1 font-serif text-[88px] font-black leading-none text-cta md:text-[110px]" data-id="element-244" data-mp="bm72kvooimgx">
                $27
              </p>
              <p className="text-lg font-bold text-navy" data-id="element-245" data-mp="1s60du2ixiy05">USD · one-time payment</p>
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-246" data-mp="25xf6l12n2dke">
              {offerIncludes.map(item => <li key={item} className="flex items-center gap-2.5 font-semibold text-navy" data-id="element-247" data-mp="214vl7hxpme51">
                  <CheckIcon className="h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-248" data-mp="2ft8gsdsvxuz0" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8" data-id="element-249" data-mp="2ouzplriq2hx3">
              <CtaButton label="Yes, I want Ortho Treatment Map™" note="One-time payment of $27 USD · Immediate access · 7-Day Guarantee" data-id="element-250" data-mp="2otyclhi5blcq" />
            </div>

            <p className="mt-4 flex items-start justify-center gap-2 rounded-xl bg-canvas px-4 py-3 text-center text-sm font-medium text-navy" data-id="element-251" data-mp="uhqksd14fkl6">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky" aria-hidden="true" data-id="element-252" data-mp="rwskutezzudt" />
              The currency conversion is automatically calculated according to your country.
            </p>
          </div>
        </div>

        <p className="mx-auto mt-8 max-w-lg text-center text-[17px] leading-relaxed text-sky-light" data-id="element-253" data-mp="10x79a1n9dplj">
          For less than the cost of many routine clinical supplies, you’ll have a reusable treatment-planning system you can return to
          every time you face a complex orthodontic case.
        </p>

        <Countdown tone="dark" data-id="element-254" data-mp="d8xq77hfjfy3" />
        <ScarcityBar tone="dark" data-id="element-255" data-mp="d85y46n1k0ck" />
      </div>
    </section>;
}